// This is probably no longer needed
import { useEffect, useState } from 'react';
import { getAlgoliaIndexNameEvents } from '@general/helpers/search.helpers';
import useAlgoliaClient from '@hooks/search/useAlgoliaClient';

const useEvent = eventCode => {
    const { searchClient } = useAlgoliaClient();
    const [event, setEvent] = useState(null);

    useEffect(() => {
        if (!searchClient || !eventCode) {
            return;
        }

        (async () => {
            const { results } = await searchClient.search([
                { indexName: getAlgoliaIndexNameEvents(), params: { filters: `event_code:${eventCode}` } },
            ]);

            if (results.length > 0 && results[0].hits.length > 0) {
                const algoliaEvent = results[0].hits[0];
                setEvent({
                    ...algoliaEvent,
                    meeting_start_time: new Date(algoliaEvent.meeting_start_time),
                    meeting_end_time: new Date(algoliaEvent.meeting_end_time),
                });
            }
        })();
    }, [eventCode, searchClient]);

    return event;
};

export default useEvent;
